import type { InviteResponse, OrganisationMembersResponse } from '../types/api';
import { ApiError } from './chat';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

async function apiError(res: Response): Promise<ApiError> {
  const body = await res.json().catch(() => null);
  return new ApiError(body?.detail?.code, body?.detail?.message ?? `HTTP ${res.status}`);
}

/** Who has access through the caller's organisation. Admin only; a 403 is an ApiError. */
export async function fetchOrganisationMembers(): Promise<OrganisationMembersResponse> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/organisation/members`);
  if (!res.ok) throw await apiError(res);
  return res.json() as Promise<OrganisationMembersResponse>;
}

/**
 * Give a colleague access to the caller's organisation.
 *
 * The backend answers with a code the dialog can act on: `invite_cap_reached` (429),
 * `not_admin` (403), `platform_unavailable` (502), or a 422 for an address it could not
 * read. No email is sent by this call; the dialog hands the admin the instructions.
 */
export async function inviteMember(email: string, name: string): Promise<InviteResponse> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/organisation/members`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, name }),
  });
  if (!res.ok) throw await apiError(res);
  return res.json() as Promise<InviteResponse>;
}
